import React from 'react';
import { Box, Grid } from '@mui/material';
import { CheckCircle as CheckCircleIcon, Error as ErrorIcon } from '@mui/icons-material';

const SystemHealthTab = ({ metrics }) => {
  const queue = metrics.queues.managerIntelSync;

  const systems = [
    {
      name: 'Database',
      status: 'healthy',
      uptime: '99.9%',
      lastCheck: new Date().toLocaleString(),
      icon: '🗄️',
    },
    {
      name: 'Redis / Queue',
      status: queue.failed > 10 ? 'degraded' : 'healthy',
      uptime: '99.8%',
      lastCheck: new Date().toLocaleString(),
      icon: '⚡',
      details: `${queue.waiting} waiting, ${queue.active} active, ${queue.failed} failed`,
    },
    {
      name: 'Manager Intel Sync',
      status: metrics.managerIntel.errorCount > 5 ? 'error' : 'healthy',
      uptime: '98.5%',
      lastCheck: new Date().toLocaleString(),
      icon: '🧠',
      details: `${metrics.managerIntel.errorCount} errors`,
    },
    {
      name: 'Orphan Marketplace',
      status: 'healthy',
      uptime: '99.9%',
      lastCheck: new Date().toLocaleString(),
      icon: '🏪',
      details: `${metrics.orphansListed.active} active listings`,
    },
  ];

  return (
    <Box>
      <Box
        sx={{
          background: '#064E3B',
          border: '2px solid #10B981',
          borderRadius: '12px',
          padding: '24px',
          marginBottom: '24px',
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
        }}
      >
        <Box sx={{ fontSize: '48px' }}>💚</Box>
        <Box>
          <Box sx={{ fontSize: '24px', fontWeight: 700, marginBottom: '4px' }}>
            All Systems Operational
          </Box>
          <Box sx={{ fontSize: '14px', color: '#D1FAE5' }}>
            Last health check: {new Date().toLocaleString()}
          </Box>
        </Box>
      </Box>

      <Grid container spacing={3}>
        {systems.map((system, index) => (
          <Grid item xs={12} md={6} key={index}>
            <Box
              sx={{
                background: '#1E293B',
                border: `2px solid ${
                  system.status === 'healthy' ? '#10B981' : system.status === 'degraded' ? '#F59E0B' : '#EF4444'
                }`,
                borderRadius: '12px',
                padding: '24px',
                position: 'relative',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
                },
                transition: 'all 0.2s',
              }}
            >
              <Box
                sx={{
                  position: 'absolute',
                  top: '20px',
                  right: '20px',
                }}
              >
                {system.status === 'healthy' ? (
                  <CheckCircleIcon sx={{ fontSize: '32px', color: '#10B981' }} />
                ) : (
                  <ErrorIcon sx={{ fontSize: '32px', color: '#EF4444' }} />
                )}
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                <Box sx={{ fontSize: '32px' }}>{system.icon}</Box>
                <Box sx={{ fontSize: '20px', fontWeight: 700, color: '#F1F5F9' }}>
                  {system.name}
                </Box>
              </Box>

              <Box sx={{ marginBottom: '16px' }}>
                <Box
                  sx={{
                    display: 'inline-block',
                    padding: '6px 12px',
                    borderRadius: '6px',
                    background:
                      system.status === 'healthy' ? '#065F46' : system.status === 'degraded' ? '#78350F' : '#7F1D1D',
                    fontSize: '12px',
                    fontWeight: 700,
                    textTransform: 'uppercase',
                    color: '#FFF',
                  }}
                >
                  {system.status}
                </Box>
              </Box>

              <Box sx={{ fontSize: '14px', color: '#94A3B8', marginBottom: '8px' }}>
                Uptime: <Box component="span" sx={{ fontWeight: 700, color: '#10B981' }}>{system.uptime}</Box>
              </Box>
              {system.details && (
                <Box sx={{ fontSize: '13px', color: '#94A3B8', marginBottom: '8px' }}>
                  {system.details}
                </Box>
              )}
              <Box sx={{ fontSize: '12px', color: '#64748B' }}>
                Last checked: {system.lastCheck}
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default SystemHealthTab;
